import { createSelector } from '@reduxjs/toolkit'

import { selectIsMarketYoyGrowthPreviousFYearSelected } from './selectIsMarketYoyGrowthPreviousFYearSelected'
import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'
import { selectMarketYoyGrowthExpectationsWorkflowState } from './selectMarketYoyGrowthExpectationsWorkflowState'

/**
 * Growth cells are editable depending on both the global workflow state and
 * the acting user's view: WorldWide users can edit in `draft` and
 * `published`, but never `locked`; Market users can edit only in
 * `published`. Either way, the dataset must not be otherwise locked
 * (`planning.isLocked`), and the currently selected fiscal year must be the
 * current one — a previous year is always read-only, regardless of its own
 * workflow status.
 */
export const selectIsMarketYoyGrowthExpectationsEditable = createSelector(
  [
    selectMarketYoyGrowthExpectationState,
    selectMarketYoyGrowthExpectationsWorkflowState,
    selectIsMarketYoyGrowthPreviousFYearSelected,
  ],
  (state, workflowState, isPreviousFYearSelected) => {
    if (state.planning?.isLocked !== false || isPreviousFYearSelected) {
      return false
    }

    const isMarketView = state.userInfo?.viewType === 'Market'

    return isMarketView
      ? workflowState === 'published'
      : workflowState === 'draft' || workflowState === 'published'
  }
)
